import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

type MobileGalleryProps = {
  items: Array<{
    id: number;
    title: string;
    slug: string;
    description: string;
    imageUrl: string;
    properties?: string;
  }>;
};

const MobileGallery: React.FC<MobileGalleryProps> = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const galleryRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (galleryRef.current) {
      const scrollOffset = activeIndex * (galleryRef.current.clientWidth * 0.9);
      galleryRef.current.scrollTo({ left: scrollOffset, behavior: "smooth" });
    }
  }, [activeIndex]);

  return (
    <div className="relative w-full overflow-hidden">
      <div
        ref={galleryRef}
        className="flex gap-4 overflow-x-auto scrollbar-hide snap-x snap-mandatory"
        style={{
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {items.map((item, index) => (
          <motion.div
            key={item.id}
            className="relative w-[90%] h-[40rem] rounded-lg shadow-lg cursor-pointer flex-shrink-0 snap-center"
            onClick={() => {
              if (index === activeIndex) {
                navigate(`/developments/${item.slug}`);
              } else {
                setActiveIndex(index);
                navigate(`/developments/${item.slug}`);
              }
            }}
          >
            <img
              src={item.imageUrl}
              alt={item.title}
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="absolute inset-x-0 bottom-0 bg-[rgba(0, 0, 0, 0.10)] backdrop-blur-md text-white p-[1.5rem] border border-transparent rounded-[0.5rem]">
              <h6 className="mb-[0.3rem] text-[2rem]/[2rem] text-white">
                {item.title}
              </h6>
              <p className="mb-[0.3rem] text-[1.2rem]">{item.description}</p>
              {item.properties && (
                <div className="flex flex-wrap gap-2">
                  {item.properties
                    .split(",")
                    .splice(0, 3)
                    .map((property) => property.trim())
                    .map((property, i) => (
                      <span
                        key={i}
                        style={{ background: "rgba(255, 255, 255, 0.10)" }}
                        className="text-white text-[1rem] p-[0.8rem] rounded-[0.5rem] whitespace-nowrap"
                      >
                        {property}
                      </span>
                    ))}
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default MobileGallery;
